module.exports = __webpack_public_path__ + "static/media/droopy_upper.a72aed07.svg";